/**
 * 接口模块
 */
import { request } from '../utils/request'

const urls = {
  addUserRequestBuryRecordAll: 'https://rclog.rcplatformhk.com/api/h5/1/addUserRequestBuryRecordAll'
}
/**
 *
 * @param a  埋点传输的数据
 * @returns {Promise<*>}
 */
export const addUserRequestBuryRecordAll = async function (a) {
  try {
    let { data } = await request.post(urls.addUserRequestBuryRecordAll, a, { params: { noLoading: 1 } })
    return data.data
  } catch (e) {
  }
}
